import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from 'react-query';
import { BillingCreateRequest } from './Billing.types';
import {
  createBillingInvoice,
  getBillingInvoiceId,
  updateBillingInvoice,
} from './Billing.service';
import { notification } from 'antd';
import { useServiceError } from '@/hooks';

export function useGetBillingInvoiceId() {
  const mutation = useMutation((invoiceId: number) =>
    getBillingInvoiceId(invoiceId),
  );
  useServiceError(mutation.error);
  return mutation;
}

export function useBillingInvoice() {
  const intl = useIntl();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: BillingCreateRequest) => createBillingInvoice(obj),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'invoice.invoicePaymentCondition.notifications.success.title',
          }),
          description: intl.formatMessage({
            id: 'invoice.invoicePaymentCondition.notifications.create.success.description',
          }),
        });

        queryClient.invalidateQueries(['paymentMethodInvoice']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useUpdateBillingInvoice() {
  const intl = useIntl().formatMessage;
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: BillingCreateRequest) => updateBillingInvoice(obj),
    {
      onSuccess() {
        notification.success({
          message: intl({
            id: 'invoice.invoicePaymentCondition.notifications.success.title',
          }),
          description: intl({
            id: 'invoice.invoicePaymentCondition.notifications.update.success.description',
          }),
        });

        queryClient.invalidateQueries(['paymentMethodInvoice']);
      },
    },
  );
  useServiceError(mutation.error);
  return mutation;
}
